import _ from 'underscore';

const getSerializableGym = (gym) => {
  const serializableGym = _.omit(
    gym,
    'classrooms',
    'events',
    'form_sections',
    'membership_plan_categories',
    'member_forms',
    'non_attending_contact_forms',
    'prospect_forms',
    'website',
    '_model',
  );
  serializableGym.users = gym.users.asJson();
  return serializableGym;
};

export default getSerializableGym;
